import React from "react";
import profile from "../files/profile.png";
import github from "../files/github_logo.png";
import twitter from "../files/twitter_logo.png";
import gg_scholar from "../files/google-scholar-logo.png";
import cv from "../files/cv.pdf";

const About = () => {

    return (
        <div class="container mx-auto px-0 pt-0 sm:px-5 sm:pt-5 md:px-10 lg:px-20 lg:pt-10">
            
            <div class="font-mono flex flex-col max-md:items-center">
                <p class="text-3xl sm:text-4xl lg:text-5xl font-extrabold">Son Tran</p>
                <p class="text-sm sm:text-lg lg:text-2xl"> tran_s2@denison.edu</p>
            </div>

            <div class="flex flex-col-reverse md:flex md:flex-row pt-10 pb-5 font-['Times'] text-base sm:text-lg lg:text-xl md:text-2xl max-md:items-center">
                <div class="md:pr-10 container text-justify">
                        I am an incoming CS PhD at Cornell University.<br/>
                        My research interests lie broadly in Natural Language Processing (NLP). 
                        I am working as a research assistant, focusing on two main research directions:
                        <br/>
                            <li class="pl-14"><span class="text-red-700"><b>Reliability of NLP systems</b></span>: I have a strong interest in 
                            investigating the vulnerability of NLP systems to <b>adversarial 
                            attacks</b> and <b>distribution shifts</b>. I believe that ensuring the 
                            robustness of NLP systems in these scenarios is crucial for their 
                            real-world applications. Additionally, I conduct research on the 
                            <b> biases</b> that can arise in NLP systems 
                            during the pre-training and fine-tuning processes.</li>

                            <li class="pl-14"><span class="text-red-700"><b>Low-Resource NLP</b></span>: I am particularly passionate 
                            about advancing NLP in low-resource languages. In this regard,
                            my research has focused on <b>automatically generating data</b>, 
                            aiming to overcome the challenges posed by limited resources.</li>
                        <br/>
                        During my undergraduate, I was advised by
                        <a href="http://personal.denison.edu/~kretchmar/" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Dr. Matt Kretchmar</u> </a>
                        , 
                        <a href="https://scholar.google.com.vn/citations?user=v3RSwOkAAAAJ&hl=en" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Kiet Van Nguyen</u></a>
                        , and 
                        <a href="https://scholar.google.com.vn/citations?user=VoTCbXYAAAAJ&hl=en" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Dr. Ngan Luu-Thuy Nguyen</u></a>
                        .
                </div>
                
                <div class="flex items-center justify-start flex-col w-6/12 sm:w-4/12 pb-7">
                    <img class="rounded-full border border-gray-100 shadow-sm 2xl:w-7/12" src={profile} alt=""/>
                    <div class="inline-grid grid-cols-3 w-fit h-fit w-6/12 sm:w-7/12 lg:w-8/12">
                        <a class="float-left" href="https://github.com/sonqt" target="_blank" rel="noopener noreferrer">
                            <img class="hover:opacity-70" src={github} alt="Github" width="40" className="icon"/>
                        </a>
                        <a class="float-left" href="https://twitter.com/sonqt01" target="_blank" rel="noopener noreferrer">
                            <img class="hover:opacity-70" src={twitter} alt="Twitter" width="40" className="icon"/>
                        </a>
                        <a class="float-left" href="https://scholar.google.com/citations?user=De7jXQUAAAAJ&hl=en" target="_blank" rel="noopener noreferrer">
                            <img class="hover:opacity-70" src={gg_scholar} alt="Google Scholar" width="40"lassName="icon"/>
                        </a>
                    </div>
                </div>            
            </div>

            <button class="bg-red-700 hover:bg-red-600 text-white font-bold py-1 px-2 lg:py-2 lg:px-4 rounded text-sm sm:text-base md:text-lg lg:text-xl" onClick={()=> window.open(cv,"_blank")}>
                Curriculum Vitae
            </button>

            

        </div>
        
);
};

export default About;
